import { useState, useCallback, useEffect } from "react";
import React from "react";
import "../Home/Home.css";
import "../AdminUserList/Admin.css";
import { toast, Slide } from "react-toastify";
import { AdminHeader } from "../Header/AdminHeader";
import { AdminSidebar } from "../Sidebar/AdminSidebar";
import { ExportFileButton } from "_components/ExportFileButton";
import { SearchOrder } from "_components/SearchOrder";
import { Filter } from "_components/Filter";
import FilterChips from "_components/FilterChips";
import CustomTable from "_components/CustomTable";
import { FilterModal } from "_components/filterModal";
import { useCustomTable } from "_hooks/useCustomTable";
import jobListColumns from "_components/mapper/jobListColumns";
import { exportJobList, getInterfaceList, getJobList } from "_services/jobListApi";

export { JobsList };

function JobsList() {
  const pageSize = 20;
  const [selectId, setSelectId] = useState([]);
  const [selectAllActive, setSelectAllActive] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [jobNameOptions, setJobNameOptions] = useState([]);

  useEffect(() => {
    const fetchJobList= async () => {
      setLoading2(true);
      const resp = await getJobList();
      setJobNameOptions(resp?.data);
      setLoading2(false)
    };
    fetchJobList()
  }, []);

  const fetchDataFn = async () => {
    return await getInterfaceList({
      page,
      pageSize,
      sortField: sortBy[0]?.id || "",
      sortOrder: sortBy[0]?.desc ? "DESC" : "ASC",
      searchQuery: searchQuery ? searchQuery.trim() : "",
      filters,
    });
  };

  const {
    loading,
    totalCount,
    page,
    filters,
    setFilters,
    searchQuery,
    setSearchQuery,
    resetStoreData,
    fetchMoreData,
    fetchData,
    filterModalOpen,
    setFilterModalOpen,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state: { sortBy },
  } = useCustomTable({
    defaultColumns: jobListColumns,
    fetchDataFn,
    setSelectAllActive,
    setSelectValue: setSelectId,
  });

  const filtersObj = [
    { label: "Create Date", key: "createDate", type: "date" },
    { label: "Job Name", key: "jobName", type: "customDropDown", filterOptions:jobNameOptions },
  ];

  const applyFilters = (filter) => {
    let formmattedFilter = {};
    Object.keys(filter).map((filterKey) => {
      if (Array.isArray(filter[filterKey])) {
        formmattedFilter[filterKey] = filter[filterKey]
          .map((item) => item.trim())
          .filter((item) => item);
      } else {
        formmattedFilter[filterKey] = filter[filterKey];
      }
    });
    setFilterModalOpen(false);
    resetStoreData();
    setFilters(formmattedFilter);
  };

  const [load, setLoad] = useState(false);
  const getDownload = async () => {
    setLoad(true);
    if (selectAllActive) {
      await exportJobList({
        sortField: sortBy[0]?.id || "",
        sortOrder: sortBy[0]?.desc ? "DESC" : "ASC",
        searchQuery: searchQuery ? searchQuery.trim() : "",
        filters
      });
    } else if (selectId.length > 0) {
      await exportJobList({
        id: selectId
      });
    } else {
      toast.error("❗ Please select atleast one value", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setLoad(false);
  };

  const removeFilter = useCallback((filterKey, value, dateKey) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      const currentFilter = newFilters[filterKey];
      if (Array.isArray(currentFilter)) {
        newFilters[filterKey] = currentFilter.filter((item) => item !== value);
        if (newFilters[filterKey].length === 0) {
          delete newFilters[filterKey];
        }
      } else if (value instanceof Date && newFilters[filterKey]) {
        delete newFilters[filterKey];
      } else {
        delete newFilters[filterKey];
      }
      return newFilters;
    });
    resetStoreData();
  }, []);

  return (
    <div className="admin-details-page-sec">
      <AdminSidebar />
      <div className="admin-details-page-body">
        <AdminHeader />
        <div className="admin-details-info">
          <div className="overview-title-sec d-flex align-center justify-between gap-4">
            <div className="search-filter-part relative d-flex align-center justify-between">
              <div className="search-filter-part relative d-flex align-center justify-between">
                <SearchOrder
                  filter={searchQuery}
                  setFilter={setSearchQuery}
                  resetData={resetStoreData}
                />
                <Filter click={() => setFilterModalOpen(true)} />
                <ExportFileButton load={load} getDownload={getDownload} />
              </div>
            </div>
          </div>
          <FilterChips
            filters={filters}
            removeFilter={removeFilter}
            setFilterModalOpen={setFilterModalOpen}
          />

          <div className="all-listing-table table-sec jobs-table">
            <CustomTable
              totalCount={totalCount}
              getTableProps={getTableProps}
              fetchMoreData={fetchMoreData}
              getTableBodyProps={getTableBodyProps}
              headerGroups={headerGroups}
              rows={rows}
              pageSize={pageSize}
              prepareRow={prepareRow}
              page={page}
              loading={loading}
              selectAllActive={selectAllActive}
              setSelectAllActive={setSelectAllActive}
              resetStoreData={resetStoreData}
              selectedInput={selectId}
              setSelectedInput={setSelectId}
              // gotoPage={gotoPage}
              selectionColKey={"id"}
              selectionColName={"File Name"}
              loadMore={totalCount > (page + 1) * pageSize}
              checkBoxReq={true}
            />
          </div>
        </div>
      </div>
      {filterModalOpen && (
        <FilterModal
          onClose={() => setFilterModalOpen(false)}
          applyFilters={applyFilters}
          selectedFilters={filters}
          filtersObj={filtersObj}
          loading2={loading2}
        />
      )}
    </div>
  );
}
